module.exports = __webpack_public_path__ + "static/media/yellow_nebula_DN.1ebc6bad.png";